// Mapping network IDs to names from https://github.com/ethereum/EIPs/blob/master/EIPS/eip-155.md.
export const NETWORK_NAMES = Object.freeze({
  1: 'Ethereum Mainnet',
  2: 'Expanse Mainnet',
  3: 'Ropsten',
  4: 'Rinkeby',
  30: 'Rootstock Mainnet',
  31: 'Rootstock testnet',
  42: 'Kovan',
  61: 'Ethereum Classic Mainnet',
  62: 'Ethereum Classic testnet',
  1337: 'Geth Private chain',
  default: 'Unknown',
});

export const TERMS_OF_SERVICE_URL = '/Terms_of_Service.pdf';

export const CampaignStatuses = Object.freeze({
  draft: 'draft',
  sending: 'sending',
  confirmingSend: 'confirming',
  failed: 'failed',
  active: 'active',
  cancelling: 'cancelling',
  confirmingCancel: 'confirming cancel',
  cancelled: 'cancelled',
});

export const RewardStatuses = Object.freeze({
  failed: 'failed',
  active: 'active',
  cancelling: 'cancelling',
  confirmingCancel: 'confirming cancel',
  cancelled: 'cancelled',
  redeeming: 'redeeming',
  confirmingRedeem: 'confirming redeem',
  redeemed: 'redeemed',
});

export const CODE_DELIMITER = '#';

export const BALANCE_ALLOWANCE_POLL_FREQUENCY = 500;

export const APP_NAME = 'Tabby Rewards';

export const REDEEMED_CODE_ERROR = 'This reward is no longer redeemable.';

export const SUPPORT_LINK = 'mailto:support@blockcat.io';

export const CAMPAIGN_ID_LENGTH = 12;

export const REWARD_CODE_LENGTH = 32;



// WEBPACK FOOTER //
// ./src/constants.js